import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import ProfileContext from "../../components/ProfileContext";
import Toast from "../../components/ToastContainer/CustomToast";
import httpCommon from "../../config/http-common";
import { getCompanySafetyVideo } from "../../slices/SafetyVideoSlice";
import CommonUtil from "../../Util/CommonUtils";

export default function SafetyVideoAcknowledgementForSelfRegistration(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const [videoAcknowledged, setVideoACknowledged] = useState(false);
  const [videoURL, setVideoURL] = useState("");
  const dispatch = useDispatch();
  const { setCurrentTotalVisitCount } = useContext(ProfileContext);
  const [state, setState] = useState(props?.location.dto);
  const companyId = localStorage.getItem("companyId")
    ? localStorage.getItem("companyId")
    : props?.location?.companyId;

  useEffect(() => {
    loadCompanySafetyVideos();
  }, []);

  const loadCompanySafetyVideos = () => {
    let payload = {
      companyId: companyId,
    };
    dispatch(getCompanySafetyVideo(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4000" && res.data) {
          setVideoURL(res.data[0]?.videoURL);
        }
      });
  };

  const handleSubmit = () => {
    if (!videoAcknowledged) {
      Toast(t("VIDEO_ACKNOWLEDGE_ERROR"), "error");
      return;
    }
    if (!props?.location?.success) {
      httpCommon
        .unsecuredAxios()
        .post("/web/visit/create_detail/selfRegistartion", {
          ...state,
          companyId,
        })
        .then((data) => {
          if (data.data.code === "CVAI0067") {
            setCurrentTotalVisitCount(data.data.data.currentVisitCount);
            if (!CommonUtil.isEmptyString(data.data.data.profilePhotoURL)) {
              localStorage.clear();
            }
            history.push({
              pathname: "/vis/visit-success",
              state: {
                message: "Self Registration created successfully",
                success: true,
              },
            });
          } else {
            Toast(data.data.message, "error");
          }
        });
    } else {
      history.push({
        pathname: "/vis/visit-success",
        state: {
          message: "Self Registration created successfully",
          success: true,
        },
      });
    }
  };

  const handleChange = (event) => {
    setVideoACknowledged(event.target.checked);
  };

  return (
    <>
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          padding: "16px",
        }}
      >
        <Box
          sx={{
            paddingTop: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography variant="h3">Video View</Typography>
        </Box>

        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            paddingTop: "16px",
          }}
        >
          <ReactPlayer
            src={videoURL}
            controls={true}
            height="100%"
            width="100%"
            style={{
              objectFit: "cover",
            }}
          />
        </Box>

        <Box
          sx={{
            backgroundColor: "#fff",
            borderTop: "1px solid #ddd",
            position: "sticky",
            bottom: 0,
            paddingLeft: "16px 0px 16px 0px",
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={videoAcknowledged}
                    onChange={handleChange}
                    sx={{
                      "&.Mui-checked": { color: "rgb(242, 130, 76)" },
                      color: "#949596",
                      "&.Mui-disabled": { color: "#949596" },
                    }}
                  />
                }
                label="I have watched the video and understood the safety instructions"
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                paddingBottom: "10px",
                justifyContent: {
                  xs: "center",
                  sm: "center",
                  md: "flex-end",
                },
              }}
            >
              <SubmitButtons variant="contained" onClick={handleSubmit}>
                <Typography variant="body1" style={{ textTransform: "none" }}>
                  Confirm
                </Typography>
              </SubmitButtons>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
